import React, { useState } from 'react';
import './SignUp.css';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../../services/auth.service';

const SignUp: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState('');
  const [successful, setSuccessful] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    setSuccessful(false);

    if (formData.password !== formData.confirmPassword) {
        setMessage("Οι κωδικοί δεν ταιριάζουν!");
        return;
    }

    AuthService.register(formData.firstName, formData.lastName, formData.email, formData.phoneNumber, formData.password).then(
      (response) => {
        setMessage(response.message || "Η εγγραφή ολοκληρώθηκε επιτυχώς!");
        setSuccessful(true);
        setTimeout(() => {
             navigate('/login');
        }, 2000);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setMessage(resMessage);
        setSuccessful(false);
      }
    );
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="firstName">Όνομα</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Το όνομά σας"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Επώνυμο</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Το επώνυμό σας"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Το email σας"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phoneNumber">Τηλέφωνο</label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="Το τηλέφωνό σας"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Κωδικός</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Ο κωδικός σας"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Επιβεβαίωση Κωδικού</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Επιβεβαιώστε τον κωδικό"
              required
            />
          </div>

          {message && (
             <div className="form-group">
               <div className={successful ? "alert alert-success" : "alert alert-danger"} role="alert" style={{color: successful ? 'green' : 'red', marginBottom: '10px'}}>
                 {message}
               </div>
             </div>
          )}

          <button type="submit" className="signup-btn">Δημιουργία Λογαριασμού</button>
        </form>
        <div className="signup-footer">
            <p>Έχετε ήδη λογαριασμό; <Link to="/login">Σύνδεση</Link></p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
